import { render } from "./ProfileCoverMediaItem.vue?vue&type=template&id=acb8043e&scoped=true"
import script from "./ProfileCoverMediaItem.vue?vue&type=script&lang=js"
export * from "./ProfileCoverMediaItem.vue?vue&type=script&lang=js"

import "./ProfileCoverMediaItem.vue?vue&type=style&index=0&id=acb8043e&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb8043e"]])

export default __exports__